(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("leftslip", [], factory);
	else if(typeof exports === 'object')
		exports["leftslip"] = factory();
	else
		root["leftslip"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 